// URI-safe pattern: allows letters, numbers, hyphens, underscores, and dots
export const URI_SAFE_PATTERN = /^[a-zA-Z0-9._-]+$/;
